import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from '@fortawesome/pro-duotone-svg-icons';
import { Box, Typography } from "@mui/material";

const PostDate = ({ date }: { date: string }) => {
    return <Box>
        <Typography 
            component={"span"}
            fontSize={'.8rem'} 
            color={"success"}
        >
            <FontAwesomeIcon
                icon={faCalendar}
                style={{ marginRight: 5 }}
            />
        </Typography>
        <Typography 
            fontSize={'.8rem'} 
            component={"span"}
            color={"text.primary"}
        >
            {
                date
            }
        </Typography>
    </Box>
}

export default PostDate;